<template>
  <div>
    <el-popover
      :popper-options="popoverOptions"
      ref="customAttrsPopover"
      placement="bottom"
      width="300"
      trigger="click"
      @after-leave="dynamicAttrKey = new Date().getTime()"
    >
      <rest-form-item :label="$t('Integrations_Otp_SMS_Field_DynamicAttrs')">
        <el-autocomplete
          :key="dynamicAttrKey"
          ref="customAttrsInput"
          v-model="dynamicAttr"
          :fetch-suggestions="querySearchAttrs"
          @select="handleSelectAttr"
          :popper-append-to-body="false"
        />
      </rest-form-item>
    </el-popover>
    <el-popover
      :popper-options="popoverOptions"
      ref="shortcodesPopover"
      placement="bottom"
      width="300"
      trigger="click"
      @after-leave="shortcodesKey = new Date().getTime()"
    >
      <rest-form-item :label="$t('Integrations_Otp_SMS_Field_Shortcodes')">
        <el-autocomplete
          :key="shortcodesKey"
          ref="shortcodesInput"
          v-model="shortcodesAttr"
          :fetch-suggestions="querySearchShortcodes"
          @select="handleSelectShortcodes"
          :popper-append-to-body="false"
        />
      </rest-form-item>
    </el-popover>
    <div class="container">
      <div class="actions" v-if="textarea">
        <el-button-group>
          <el-button v-if="emoji" class="dropdown-btn emoji-picker-textarea">
            <emoji-picker :on-select="insertEmoji" />
          </el-button>
          <el-button
            v-if="attributes"
            v-popover:customAttrsPopover
            @click="putCursor('customAttrsInput')"
            class="dropdown-btn"
            icon="el-icon-user-solid"
          />
          <el-button
            v-if="shortcodes"
            v-popover:shortcodesPopover
            @click="putCursor('shortcodesInput')"
            class="dropdown-btn"
            icon="icon icon-code"
          />
        </el-button-group>
      </div>
      <el-input v-model="inputVal" :type="type" v-loading="loading">
        <div slot="append" class="btn-group" v-if="!textarea">
          <el-button v-if="emoji" class="emoji-picker dropdown-btn">
            <emoji-picker :on-select="insertEmoji" />
          </el-button>
          <el-button
            v-if="attributes"
            v-popover:customAttrsPopover
            @click="putCursor('customAttrsInput')"
            class="dropdown-btn"
            icon="el-icon-user-solid"
          />
          <el-button
            v-if="shortcodes"
            v-popover:shortcodesPopover
            @click="putCursor('shortcodesInput')"
            class="dropdown-btn"
            icon="icon icon-code"
          />
        </div>
      </el-input>
    </div>
  </div>
</template>

<script>
import EmojiPicker from '@/common/components/EmojiPicker'
import { $hasFeature } from '@/core/utils/VueAcl'
import { querySearch } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'OtpSmsMessageInput',
  components: { RestFormItem, EmojiPicker },
  mounted() {
    EventBus.$on('fetchingData', isFetching => {
      this.loading = isFetching
    })
  },
  destroyed() {
    EventBus.$off('fetchingData')
  },
  data() {
    return {
      dynamicAttrKey: '',
      shortcodesKey: '',
      dynamicAttr: '',
      shortcodesAttr: '',
      popoverOptions: {
        modifiers: [this.hidePopover, 'offset', 'arrow', 'applyStyle']
      },
      loading: false
    }
  },
  props: {
    value: {
      required: true
    },
    emoji: {
      type: Boolean,
      required: false,
      default: true
    },
    attributes: {
      type: Boolean,
      required: false,
      default: false
    },
    shortcodes: {
      type: Boolean,
      required: false,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    inputVal: {
      get() {
        if (this.value === null) {
          return ''
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    textarea() {
      return this.type === 'textarea'
    }
  },
  methods: {
    hidePopover(data) {
      const refRect = data.offsets.reference
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64
      data.styles.display = refRect.bottom - headerHeight < 0 ? 'none' : 'block'
      return data
    },
    putCursor(ref) {
      setTimeout(() => {
        this.$refs[ref].focus()
      }, 0)
    },
    insertEmoji(emoji) {
      this.inputVal += emoji.data
    },
    querySearchAttrs(queryString, cb) {
      return querySearch(
        `tags`,
        { sort: 'title', show_aliases: 0, title: queryString },
        cb
      )
    },
    handleSelectAttr(item) {
      const check = item.value.match('^[a-zA-Z]+[a-zA-Z0-9_.]{0,}$')
      if ($hasFeature('twig')) {
        if (check) {
          this.inputVal += `{{ ${item.value} }}`
        } else {
          let path = item.value.replaceAll(`'`, `\\'`)
          this.inputVal += `{{ user.attributes['${path}'] }}`
        }
      } else {
        this.inputVal += `{{ ${item.value} }}`
      }
      this.dynamicAttr = ''
      this.putCursor('customAttrsInput')
    },
    querySearchShortcodes(queryString, cb) {
      const shortcodes = [{ title: 'OTP_CODE', value: 'OTP_CODE' }]

      cb(shortcodes)
    },
    handleSelectShortcodes(item) {
      this.inputVal += `{{ ${item.value} }}`
      this.shortcodesAttr = ''
      this.putCursor('shortcodesInput')
    }
  }
}
</script>

<style scoped>
.emoji-picker-textarea {
  padding: 0 !important;
}
.emoji-picker-textarea >>> .el-button {
  padding-left: 7px;
  border: none;
  line-height: 0.7;
  width: 100%;
  height: 100%;
  border-radius: 0;
}
>>> .emoji-picker .btn-icon {
  line-height: 14px;
}
.dropdown-btn {
  padding: 8px;
  width: 35px;
  height: 35px;
  background-color: #fff;
}
.btn-group {
  display: flex;
}
.actions {
  position: absolute;
  z-index: 99;
  right: 0;
}
>>> .el-textarea__inner {
  padding-top: 31px !important;
  height: 120px;
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/otp/components/OtpSmsMessageInput.vue